<div class="flex flex-col">
  <!-- Header commun : titre + bouton X -->
  @if(overrideHaeder()){
  <ng-content   select="[header]"></ng-content> 
  } @else {
    <div class="flex items-center justify-between px-3 py-1">
        <span class="font-semibold text-sm">
          @if (legendMode()) {
            {{ '' | libTranslateLang: 'Legend' : 'Légende' }}
          } @else {
            {{ '' | libTranslateLang: 'Filter by price' : 'Filtrer par prix' }}
          }
        </span>
        <button
          (click)="onClose()"
          [attr.aria-label]="'' | libTranslateLang: 'Close' : 'Fermer'"
          class="flex items-center justify-center rounded-full cursor-pointer bg-transparent hover:bg-gray-100"
          style="border: 1.5px solid var(--primaryBackground); padding: 5px">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 20px">close</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>
  }

 

  @for (pl of priceLevels(); track pl.id) {
    <div class="flex items-center gap-3 px-4 py-2">
      <!-- Cercle de couleur -->
      <span class="
      seat-color-pricelevelid-{{ pl.id }}
      w-5 h-5 rounded-full flex-shrink-0" [style.background-color]="
      pl.soldout? '#80808021':
      pl.color"></span>

      <!-- Nom + prix -->
      <div class="flex flex-col flex-1 min-w-0">
        <span class="font-medium text-sm">{{ pl.name }}</span>
        @if (pl.soldout) {
          <span class="text-sm font-medium text-gray-400">{{ '' | libTranslateLang: 'Sold out' : 'Complet' }}</span>
        } @else if (legendMode()) {
          @if (pl.price_min + pl.serviceCharge_min === pl.price_max + pl.serviceCharge_max) {
            <span class="text-sm font-bold">
              {{ (pl.price_min + pl.serviceCharge_min) / 100 | currency }}
            </span>
          } @else {
            <span class="text-sm font-bold">
              {{ (pl.price_min + pl.serviceCharge_min) / 100 | currency }} {{ '' | libTranslateLang: 'to' : 'à' }}
              {{ (pl.price_max + pl.serviceCharge_max) / 100 | currency }}
            </span>
          }
        } @else if (pl.price_min === pl.price_max) {
          <span class="text-sm font-bold">{{ pl.price_min / 100 | currency }}</span>
        } @else {
          <span class="text-sm font-bold">
            {{ pl.price_min / 100 | currency }} {{ '' | libTranslateLang: 'to' : 'à' }}
            {{ pl.price_max / 100 | currency }}
          </span>
        }
      </div>

      <!-- Checkbox (filtre uniquement) -->
      @if (!legendMode()) {
        <mat-checkbox
          [checked]="isSelected(pl.id)"
          (change)="onToggle(pl.id, $event.checked)"
          [disabled]="pl.soldout"></mat-checkbox>
      }
    </div>
  }

  <hr class="border-gray-200 m-0 border-dashed" />
  <!-- Boutons action (filtre) ou mention taxes incluses (légende) -->

  <div class="flex justify-between px-4 pt-3">
    @if (legendMode()) {
      <div class="ml-auto text-xs text-gray-400">{{ '' | libTranslateLang: 'Taxes included' : 'Taxes incluses' }}</div>
    } @else {
      <button mat-stroked-button (click)="onReset()">{{ '' | libTranslateLang: 'Reset' : 'Réinitialiser' }}</button>
      <button mat-flat-button color="primary" (click)="onApply()">
        {{ '' | libTranslateLang: 'Apply' : 'Appliquer' }}
      </button>
    }
  </div>
</div>
